import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';

export default function ResetPassword() {
  const { updatePassword } = useAuth();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 6) { setError('Password must be at least 6 characters'); return; }
    if (password !== confirm) { setError('Passwords do not match'); return; }
    setSaving(true);
    try {
      await updatePassword(password);
      setDone(true);
    } catch (err) {
      setError(err.message || 'Could not update password');
    } finally { setSaving(false); }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f5f6fa' }}>
      <div style={{ width: 400, background: '#fff', borderRadius: 16, boxShadow: '0 4px 24px rgba(0,0,0,0.09)', padding: '48px 40px' }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ overflow: 'hidden', height: 54, display: 'inline-block' }}>
            <img src="/travelscape-logo.png" alt="Travelscape" style={{ width: 220, display: 'block', marginTop: -4 }} />
          </div>
          <div style={{ fontSize: 13, color: '#9ca3af', marginTop: 16 }}>
            {done ? 'Password updated' : 'Set a new password'}
          </div>
        </div>

        {done ? (
          <div style={{ textAlign: 'center' }}>
            <div style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 8, padding: '14px 16px', color: '#16a34a', fontSize: 13, marginBottom: 20 }}>
              Your password has been changed. You're now signed in — continue to the app.
            </div>
            <button
              onClick={() => window.location.href = '/'}
              style={{ width: '100%', padding: 12, background: '#f07040', color: '#fff', border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 600, cursor: 'pointer' }}
            >
              Continue
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
              <div>
                <label style={{ display: 'block', fontSize: 13, fontWeight: 500, color: '#374151', marginBottom: 6 }}>New Password</label>
                <input
                  type="password" value={password} onChange={e => setPassword(e.target.value)} required autoFocus
                  placeholder="Min 6 characters"
                  style={{ width: '100%', padding: '10px 14px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14, color: '#1a1d27', outline: 'none' }}
                />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: 13, fontWeight: 500, color: '#374151', marginBottom: 6 }}>Confirm Password</label>
                <input
                  type="password" value={confirm} onChange={e => setConfirm(e.target.value)} required
                  style={{ width: '100%', padding: '10px 14px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14, color: '#1a1d27', outline: 'none' }}
                />
              </div>

              {error && (
                <div style={{ background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 8, padding: '10px 14px', color: '#dc2626', fontSize: 13 }}>{error}</div>
              )}

              <button
                type="submit" disabled={saving}
                style={{ marginTop: 4, width: '100%', padding: 12, background: saving ? '#f5a882' : '#f07040', color: '#fff', border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 600, cursor: saving ? 'not-allowed' : 'pointer' }}
              >
                {saving ? 'Saving…' : 'Set Password'}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
